module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "redbag",
    attrs: {
      "id": "redbag"
    }
  }, [_c('div', {
    staticClass: "m-header",
    style: ('background-image:url(' + _vm.imgPath + 'redbag/hongbaohead_03.png)')
  }, [_c('p', {
    staticClass: "u-title"
  }, [_vm._v("发红包")]), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": _vm.imgPath + 'redbag/redclose_03.png'
    },
    on: {
      "click": _vm.closeAction
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "m-bottom"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "m-li",
    on: {
      "click": function($event) {
        return _vm.tabSelect(0)
      }
    }
  }, [_c('a', {
    staticClass: "u-tab",
    class: {
      action: _vm.master
    }
  }, [_vm._v("打赏红包")])]), _vm._v(" "), _c('li', {
    staticClass: "m-li",
    on: {
      "click": function($event) {
        return _vm.tabSelect(1)
      }
    }
  }, [_c('a', {
    staticClass: "u-tab",
    class: {
      action: !_vm.master
    }
  }, [_vm._v("拼手气红包")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.master),
      expression: "master"
    }],
    staticClass: "m-tab1"
  }, [_c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("总金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumMoney),
      expression: "sumMoney"
    }],
    staticClass: "m-textfiled",
    attrs: {
      "type": "number",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.sumMoney)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sumMoney = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-unit"
  }, [_vm._v("元")])]), _vm._v(" "), (_vm.ds_id != 194) ? _c('p', {
    staticClass: "u-detail"
  }, [_vm._v("打赏红包为向主办方打赏")]) : _c('p', {
    staticClass: "u-detail"
  }, [_vm._v("向主演打赏")]), _vm._v(" "), _c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("留言")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "恭喜发财，大吉大利"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.master),
      expression: "!master"
    }],
    staticClass: "m-tab2"
  }, [_c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("总金额")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redsumMoney),
      expression: "redsumMoney"
    }],
    staticClass: "m-textfiled",
    attrs: {
      "type": "number",
      "placeholder": "0"
    },
    domProps: {
      "value": (_vm.redsumMoney)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redsumMoney = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-unit"
  }, [_vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "u-detail"
  }, [_vm._v("拼手气红包为向观众打赏")]), _vm._v(" "), _c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("红包个数")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rednum),
      expression: "rednum"
    }],
    staticClass: "m-textfiled",
    attrs: {
      "type": "number",
      "placeholder": "填写个数",
      "max": "50",
      "min": "1"
    },
    domProps: {
      "value": (_vm.rednum)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rednum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-unit"
  }, [_vm._v("个")])]), _vm._v(" "), _c('div', {
    staticClass: "u-input"
  }, [_c('span', {
    staticClass: "m-totalmoney"
  }, [_vm._v("留言")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redMessage),
      expression: "redMessage"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "恭喜发财，大吉大利"
    },
    domProps: {
      "value": (_vm.redMessage)
    },
    on: {
      "blur": _vm.blurAction,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redMessage = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "u-redbtn",
    on: {
      "click": function($event) {
        return _vm.sendRedAction()
      }
    }
  }, [_vm._v("发红包")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71c958ab"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/rewardRedBag.vue
// module id = 319
// module chunks = 0